import { Button } from 'antd'
import { CSVLink } from 'react-csv'
import { buildCsvString } from '../../utils/csv'

const CreditNotesCSV = ({ creditNotes }) => {
  const tableHeaders = [
    'PO Number',
    'SKU',
    'Product',
    'Supplier',
    'Reason',
    'Notes',
    'Ordered qty',
    'Credit qty',
    'Est. credit',
    'Status',
    'CN applied',
    'Source',
    'Requested by',
    'Requested',
    'Ordered Date',
    'Resolved',
  ]

  const titleOfTable = 'Credit Requests'
  const rows = []
  rows.push([titleOfTable])
  rows.push([])
  rows.push(tableHeaders)
  creditNotes?.forEach(note => {
    const {
      PON,
      SKU,
      productTitle,
      supplierTitle,
      reason,
      notesFull,
      orderedQuantity,
      quantity,
      amount,
      statusText,
      creditNoteApplied,
      source,
      requestedBy,
      requestedAt,
      createdAt,
      resolved,
    } = note
    rows.push([
      PON,
      SKU || ' ',
      productTitle,
      supplierTitle,
      reason || '',
      notesFull || '',
      orderedQuantity ?? '',
      quantity ?? '',
      amount,
      statusText || '',
      creditNoteApplied ? 'Yes' : 'No',
      source || '',
      requestedBy || '',
      requestedAt || '',
      createdAt,
      resolved ? 'Yes' : 'No',
    ])
  })

  return (
    <Button style={{ marginLeft: '15px' }}>
      <CSVLink data={buildCsvString(rows)} filename={`Credit_Requests.csv`}>
        Download CSV
      </CSVLink>
    </Button>
  )
}

export default CreditNotesCSV
